export default interface Transaction {
  id: number;
  accEvent: string;
  type: boolean;
  period: number;
  k2dTrId: number;
  externalTrId: string;
  insDate: string;
  userId: number;
  userName: string;
  status: number;
  statusName: string;
  remark: string;
  nicname: string;
  accDate: string;
  partner: number;
  partnerName: string;
  storno: boolean;
  /** llscatran_ch.is_only_elabe — sztornózott fej tétele csak ekkor pontozható (K2D) */
  isOnlyElabe: boolean;
  // A sztornózott tranzakció száma (hxboktrans.trans_st) — null, ha nincs (K2D-hűen a kézi rögzítés nem tölti)
  transSt: number | null;
  transType: number;
  typeName: string;
  isMod: boolean;
  storeIn: number;
  gstoreIn: number;
  storeOut: number;
  sourceType: number;
  sourceHead: number;
  isRevalued: boolean;
  oriTrans: number;
  bokSheetOper: string;
  bokPeriodStatus: number;
  bokPeriodStatusName: string;
  selected: boolean;
  periodName: string;
  currency: string;
  bookTypeName: string;
  selectedStatus: boolean;
  // Fej spec. dimenziók (hxboktrans.spec_dim1-4) — a fej↔tétel kizáráshoz:
  // ha bármelyik kitöltött, a tétel-grid spec dim mezői nem szerkeszthetők
  specDim1: string;
  specDim2: string;
  specDim3: string;
  specDim4: string;
}

export const TransactionDefaultProps: Transaction = {
  id: 1,
  accEvent: '',
  type: false,
  period: 1,
  k2dTrId: 1,
  externalTrId: '',
  insDate: '',
  userId: 1,
  userName: '',
  status: 1,
  statusName: '',
  remark: '',
  nicname: '',
  accDate: '',
  partner: 1,
  partnerName: '',
  storno: false,
  isOnlyElabe: false,
  transSt: null,
  transType: 1,
  typeName: '',
  isMod: false,
  storeIn: 1,
  gstoreIn: 1,
  storeOut: 1,
  sourceType: 1,
  sourceHead: 1,
  isRevalued: false,
  oriTrans: 1,
  bokSheetOper: '',
  bokPeriodStatus: 1,
  bokPeriodStatusName: '',
  selected: false,
  periodName: '',
  currency: '',
  bookTypeName: '',
  selectedStatus: false,
  specDim1: '',
  specDim2: '',
  specDim3: '',
  specDim4: '',
}